export function greeting(now: Date = new Date()): string {
  const hourStr = new Intl.DateTimeFormat('es-ES', {
    timeZone: 'Europe/Madrid',
    hour: '2-digit',
    hourCycle: 'h23',
  }).format(now);
  const h = Number.parseInt(hourStr, 10) % 24;
  if (h >= 5 && h < 13) return 'Buenos días';
  if (h >= 13 && h < 21) return 'Buenas tardes';
  return 'Buenas noches';
}
